import React, { useCallback, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { unitPrice } from '../../../../../../../utils/product'
import Ask from '../../../../components/ask'
import Tool from '../../components/click-open-banner'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import BottomToTop from '../../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../../components/mask'
import { BigButton } from '../../../../../../components/button'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { SensorsTrack } from '../../../../../../utils/sensor'


export const ApplyPoints = props => {
    useStyles(classes)
    const { expectedPoints, expectedPointDiscount, pointsDescription, points, applyPointsHandle, onClose } = props
    const [value, setValue] = useState('')
    const [loading, setLoading] = useState(false)


    const applyHandle = async p => {
        if (!loading) {
            setLoading(true)
            await applyPointsHandle(p)
            setLoading(false)
            onClose()
        }
    }

    const changeHandle = e => {
        const { value } = e.target
        try {
            if (value > expectedPoints) {
                setValue(expectedPoints)
            } else {
                setValue(value)
            }
        } catch (error) {

        }
    }

    const allHandle = () => {
        setValue(expectedPoints)
    }

    useEffect(() => {
        setValue(points||'')
    }, [points])

    return <div className={classes.ApplyPoints}>
        <div className={classes.Hd}>
            <FormattedMessage id="apply_points" defaultMessage="Apply Points" />
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Description}>
            <FormattedMessage id="max_available_count" defaultMessage="Max Available {count}" values={{ count: expectedPoints }} />
            {' '}
            <Ask content={pointsDescription} />
        </div>
        <div className={classes.Bd}>
            <div className={classes.Input}>
                <input type="number" value={value} onChange={changeHandle} />
                <span className={classes.All} onClick={allHandle}>
                    <FormattedMessage id="all" defaultMessage="All" />
                </span>
            </div>

            <BigButton className={classes.Button} disabled={!value} loading={loading} onClick={e => applyHandle(value)}>
                <FormattedMessage id="apply" defaultMessage="Apply" />
            </BigButton>
        </div>
    </div>
}


const ApplyPointsEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.ApplyPointsContainer}>
            <div>
                <ApplyPoints {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}



export default props => {
    useStyles(classes)
    const { pointsDescription, canUsePoints, expectedPoints, expectedPointDiscount, points, pointsDiscount, applyPointsHandle } = props
    const [show, setShow] = useState(false)
    const clickHandle = useCallback(e => {
        SensorsTrack('PlaceOrderAction', {action: 'ClickApplyPoints'})
        setShow(true)
    }, [])

    const label = points > 0 ? <span className={classes.Red}>-{points}</span> : <>
        <FormattedMessage id="total" defaultMessage="Total" />: {canUsePoints}
    </>

    return <>
        <Tool onClick={clickHandle} value={label}>
            <FormattedMessage id="points" defaultMessage="Points" />
            {
                pointsDiscount?.amount > '0' && `(${unitPrice(pointsDiscount)})`
            }
            <Ask content={pointsDescription} />
        </Tool>

        <ApplyPointsEditor
            show={show}
            onClose={() => setShow(false)}
            expectedPoints={expectedPoints}
            expectedPointDiscount={expectedPointDiscount}
            pointsDescription={pointsDescription}
            points={points}
            applyPointsHandle={applyPointsHandle} />
    </>
}    